const linkWrapper = document.getElementById('link-wrapper');
const form = document.getElementById('linkForm');

const search = form.querySelector('input[type="search"]');
const searchButton = form.querySelector('#searchButton');

const backButton = form.querySelector('#backButton');
const select = form.querySelector('select');
const defaultOptionsTemplate = form.querySelector('#defaultOptions');

const loadingOverlay = linkWrapper.querySelector('#loadingOverlay');
const errorMessage = linkWrapper.querySelector('#errorMessage');
const errorMessageText = linkWrapper.querySelector('#errorMessageText');

if (!linkWrapper || !form || !search || !searchButton || !backButton || !select || !errorMessage || !errorMessageText) {
    throw new Error('One or more required elements not found');
}

search.addEventListener('keydown', async (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();

        await searchLocations();
    }
});

searchButton.addEventListener('click', async () => {
    await searchLocations();
});

async function searchLocations() {
    hideErrorMessage();

    if (!search.value?.trim()) {
        return;
    }

    if (search.value === lastSearchedZipCode) {
        form.dataset.currentPage = 2;
        return;
    }

    try {
        showLoadingOverlay();

        resetToDefaultOptions();

        lastSearchedZipCode = search.value;
        const url = window.Shopify.routes.root + `apps/company-select/app/locations?q=${search.value}`
        const response = await fetch(url);

        const data = await response.json();

        if (response.ok) {
            processLocationData(data);
            form.dataset.currentPage = 2;
        } else {
            showErrorMessage(data.message);
        }
    } finally {
        hideLoadingOverlay();
    }
}

backButton.addEventListener('click', () => {
    form.dataset.currentPage = 1;
    search.focus();
});

function processLocationData(data) {
    locations = new Map(data.map((locationData) => [locationData.name, locationData]));

    if (locations.size > 0) {
        select.removeAttribute('disabled');

        const options = data.map(createLocationOption);
        options.forEach((option => {
            select.appendChild(option)
        }));

        select.focus();
        select.click();
    } else {
        select.setAttribute('disabled', 'disabled');
    }
}

let locations;
let lastSearchedZipCode;

form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!locations || locations.size === 0) {
        return;
    }

    try {
        hideErrorMessage();
        showLoadingOverlay();

        const location = locations.get(select.value);
        const payload = {
            customerId: linkWrapper.dataset.customerId,
            companyId: location.companyId,
            currentCompanyId: linkWrapper.dataset.currentCompanyId,
            locationId: location.locationId,
            roleId: location.roleId,
        };

        const response = await fetch(window.Shopify.routes.root + 'apps/company-select/app/link', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            linkWrapper.dataset.state = 'success';
        } else {
            const data = await response.json();
            showErrorMessage(data.message);
        }
    } finally {
        hideLoadingOverlay();
    }
});

function resetToDefaultOptions() {
    select.innerHTML = defaultOptionsTemplate.innerHTML;
}

function createLocationOption(location) {
    const option = document.createElement('option');
    option.value = location.name;
    option.textContent = location.name;
    return option;
}

function showErrorMessage(message) {
    errorMessage.classList.remove('pe-invisible');
    errorMessageText.textContent = message;
}

function hideErrorMessage() {
    errorMessage.classList.add('pe-invisible');
    errorMessageText.textContent = '';
}

function showLoadingOverlay() {
    loadingOverlay.classList.add('pe-flex');
    loadingOverlay.classList.remove('pe-hidden');
}

function hideLoadingOverlay() {
    loadingOverlay.classList.add('pe-hidden');
    loadingOverlay.classList.remove('pe-flex');
}